<template>

    <div class="d-flex">
        <sidebar v-if="displaySidebar"></sidebar>
        <main-container :display-sidebar="displaySidebar"></main-container>
    </div>

</template>

<script>

    import Sidebar from "./layout/Sidebar.vue";
    import MainContainer from "./layout/MainContainer.vue";
    import AppService from "./services/AppService";

    export default {
        name: 'AppContainer',
        components: {
            MainContainer,
            Sidebar
        },
        computed: {
            displaySidebar() {
                return !this.model.isMobile && this.appId && this.model.currentCollaboratorId && this.isEditAuthorized
            },
            isEditAuthorized() {
                let collaborator = webase.managers.app.currentCollaborator()
                return webase.utils.auth.isEditAuthorized(this.model.app.user_app_uuid, collaborator)
            },
            appId() {
                if(this.app) {
                    return this.app.id
                }

                return this.model.app.id
            },
        },
        data: function () {
            return {
                model: webase.model,
                app: null
            }
        },
        mounted() {
            let appId = this.$route.params.appId
            // console.log('AppContainer.mounted')
            // console.log(appId)
            // console.log('Route: ' + this.$router.currentRoute.name)

            if(appId) {
                let service = new AppService()
                service.initApp(appId).then((response) => {
                    console.log('App initialized in AppContainer')
                    this.app = response
                    webase.eventDispatcher.emit('onAppLoaded', response)
                    // this.model.app = response
                }).catch((message) => {
                    console.log('error loading app')
                    console.log(message)
                })
            }
        }
    }
</script>